require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery") 
require("jquery-ui")
require("./jquery.validationEngine")
require("./jquery.validationEngine-ja")

import "../booking/booking_choose.js";
import "../booking/booking_new.js";
import "../booking/booking_destroy_choose.js";
import "../booking/booking_detail.js";
import "../booking/script.js";
import "../booking/flash.js";
import "../booking/inquiry.js";
import "../booking/booking_export_choose.js";
import "../booking/inquiry_export_choose.js";
import "../booking/datepicker.js";
import "../booking/top.js";
import "../booking/personal_information.js";
import "../booking/csv_upload.js";
